import ApiService from "api/ApiService";
import Urls from "api/Urls";
import Config from '../constants/Config';
import AppUIModel from 'models/AppUI'

export function getAllAppUI(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.GET_LIST_APP_UI,
        params: params,
        parser: appUiDataParser,
    }).get();
}

export function getWhitelist(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.GET_WHITELIST_IP,
        params: params,
        parser: whitelistIpDataParser,
    }).get();
}

export function getDetailAppUI(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.GET_DETAIL_APP_UI,
        endpointParams: {id}
    }).get()
}

export function updateAppUIConfig(appUI) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.UPDATE_APP_UI,
    }).put(new AppUIModel(appUI).exportUpdateConfig())
}

export function createNewAppUIConfig(appUIData) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CREATE_NEW_APP_UI,
    }).post(new AppUIModel(appUIData).export());
}

export function deleteIp(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.DELETE_IP,
        endpointParams: {id}
    }).delete()
}

export function createIp(ipData) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.CREATE_IP,
    }).post(ipData);
}

export function deleteAppUIConfig(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.DELETE_APP_UI,
        endpointParams: {id}
    }).delete()
}

export function createAppUITranslate(appUIData) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.APP_UI_TRANSLATE
    }).post(new AppUIModel(appUIData).exportCreateTranslation())
}

export function updateAppUITranslate(appUIData) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.APP_UI_TRANSLATE
    }).put(new AppUIModel(appUIData).exportUpdateTranslation())
}

export function deleteAppUITranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.DELETE_APP_UI_TRANSLATE,
        endpointParams: {id}
    }).delete()
}

const appUiDataParser = (data) => ({
    result: data.data.result || [],
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})

const whitelistIpDataParser = (data) => ({
    result: data.data || [],
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalCount: data.totalRecords
})

const appUICreateData = (data) => {
    return {
        screenType: data.screenType,
        languageCode: data.languageCode,
        backgroundName: data.backgroundName,
        title: data.title,
        descriptions: data.descriptions,
        order: data.order,
        logoImageName: data.logoImageName,
        backgroundImageName: data.backgroundImageName,
        isDisplay: data.isDisplay
    }
}

const appUIUpdateConfig = (data) => {
    return{
        id: data.id,
        screenType: data.screenType,
        languageCode: data.languageCode,
        backgroundName: data.backgroundName,
        title: data.title,
        descriptions: data.descriptions,
        order: data.order,
        logoImageName: data.logoImageName,
        backgroundImageName: data.backgroundImageName,
        isDisplay: data.isDisplay
    }
}
